import { render, staticRenderFns } from "./ManageGvd.modal.vue?vue&type=template&id=25e186d5"
import script from "./ManageGvd.modal.vue?vue&type=script&lang=ts"
export * from "./ManageGvd.modal.vue?vue&type=script&lang=ts"
import style0 from "./ManageGvd.modal.vue?vue&type=style&index=0&id=25e186d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports